export default __webpack_public_path__ + "img/eb3bd1fd2e33cfb75f5e4a7ac6b270e0.png";